import { get, post, put, del } from './client'

export interface ModelDeployment {
  id: number
  name: string
  model: string
  provider?: string
  status: number
  base_url?: string
  api_key?: string
  created_time?: number
  updated_time?: number
  [key: string]: unknown
}

export interface DeploymentListResponse {
  items: ModelDeployment[]
  total: number
  page: number
  page_size: number
}

/**
 * GET /api/deployments/settings — 只读：io.net 是否启用、是否已配置密钥等
 * 与后端模型部署设置（GetModelDeploymentSettings）响应对齐
 */
export interface DeploymentSettingsResponse {
  provider?: string
  enabled?: boolean
  configured?: boolean
  can_connect?: boolean
}

export async function getDeploymentSettingsApi(): Promise<DeploymentSettingsResponse> {
  return get<DeploymentSettingsResponse>('/api/deployments/settings')
}

/**
 * POST /api/deployments/test-connection — 测试 io.net 连接；可传 api_key 或使用已保存密钥
 */
export async function testDeploymentConnectionApi(body?: { api_key?: string }): Promise<unknown> {
  return post('/api/deployments/test-connection', body ?? {})
}

/**
 * GET /api/deployments
 */
export async function getDeploymentsApi(params?: {
  p?: number
  page_size?: number
}): Promise<DeploymentListResponse> {
  return get<DeploymentListResponse>('/api/deployments/', params)
}

/**
 * GET /api/deployments/search
 */
export async function searchDeploymentsApi(keyword: string): Promise<ModelDeployment[]> {
  return get<ModelDeployment[]>('/api/deployments/search', { keyword })
}

/**
 * POST /api/deployments
 */
export async function createDeploymentApi(data: Partial<ModelDeployment>): Promise<void> {
  return post('/api/deployments/', data)
}

/**
 * PUT /api/deployments/:id
 */
export async function updateDeploymentApi(id: number, data: Partial<ModelDeployment>): Promise<void> {
  return put(`/api/deployments/${id}`, data)
}

/**
 * DELETE /api/deployments/:id
 */
export async function deleteDeploymentApi(id: number): Promise<void> {
  return del(`/api/deployments/${id}`)
}
